import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { BRAND, CONTACT } from "@/data/media";
import { MapPin, Mail } from "lucide-react";

const navLinks = [
  { to: "/", key: "home" },
  { to: "/chi-siamo", key: "about" },
  { to: "/settori", key: "sectors" },
  { to: "/produzione", key: "production" },
  { to: "/contatti", key: "contact" },
];

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="footer" className="bg-ink text-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 md:py-24 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="mb-6">
            <img src={BRAND.logoFull} alt="Sofas Contract" className="h-24 w-auto object-contain" />
          </div>
          <p className="text-white/60 max-w-sm leading-relaxed text-sm">{t.footer.tagline}</p>
          <div className="brass-line w-40 mt-8" />
        </div>

        <div className="md:col-span-3">
          <h4 className="overline mb-6">{t.footer.navTitle}</h4>
          <ul className="space-y-3">
            {navLinks.map((l) => (
              <li key={l.key}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.key}`}
                  className="text-white/70 hover:text-brass transition-colors text-sm"
                >
                  {t.nav[l.key]}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="overline mb-6">{t.footer.contactTitle}</h4>
          <ul className="space-y-4 text-sm text-white/70">
            <li className="flex gap-3">
              <MapPin className="w-4 h-4 text-brass shrink-0 mt-0.5" />
              <span>{CONTACT.address}</span>
            </li>
            <li className="flex gap-3">
              <Mail className="w-4 h-4 text-brass shrink-0 mt-0.5" />
              <a href={`mailto:${CONTACT.emailInfo}`} className="hover:text-brass transition-colors" data-testid="footer-email-info">
                {CONTACT.emailInfo}
              </a>
            </li>
            <li className="flex gap-3">
              <Mail className="w-4 h-4 text-brass shrink-0 mt-0.5" />
              <a href={`mailto:${CONTACT.emailProject}`} className="hover:text-brass transition-colors" data-testid="footer-email-project">
                {CONTACT.emailProject}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-white/40">
          <span data-testid="footer-copyright">© {new Date().getFullYear()} Sofas Contract. {t.common.allRights}. · P.IVA 04711220402</span>
          <span className="tracking-[0.2em] uppercase">Forlì · Italia</span>
        </div>
      </div>
    </footer>
  );
};
